export function sortedCSSRules(cssRules) {
  const rules = [...cssRules];
  rules.sort((a, b) => (b.startsWith('@') - a.startsWith('@')) * 10 + (b.includes(':root') - a.includes(':root')));
  return rules;
}
